import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { plainToClass, plainToClassFromExist } from 'class-transformer';
import { Subscriber } from 'rxjs';
import { MarcheAPIService } from '../@core/api/marche-api.service';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import {
    ErrorWrapper,
    ResponseWrapper,
} from '../@shared/models/response-wrapper.model';
import { GLPDATA } from './generic-listing-page.data';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { FooterPageService } from '../footer/footer-page.service';

@Component({
    selector: 'app-glp',
    templateUrl: './generic-listing-page.component.html',
    styleUrls: ['./generic-listing-page.component.scss'],
})
export class GenericListingPageComponent extends RouteExecutor
    implements OnInit {
    static readonly GLP_API = '/glp';
    @Input() filters: { [p: string]: string | string[] } = {};
    pageData: GLPDATA = new GLPDATA();
    olpShow = false;
    errors: any;
    showShimmer = true;
    constructor(
        private marcheAPIService: MarcheAPIService,
        applicationRouterService: ApplicationRouterService,
        private activatedRoute: ActivatedRoute,
        @Optional()
        public dialogRef: MatDialogRef<GenericListingPageComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public dataDialog: any,
        private footerService: FooterPageService
    ) {
        super(applicationRouterService);
        if (dataDialog?.popup === true) {
            //  this.isPagePopup = true;
            this.filters = dataDialog.query;
        } else {
            this.activatedRoute.queryParams.subscribe(param => {
                this.filters = param;
            });
        }
        this.updateSelectQueryData();
        this.footerService.updateFilter({ ...this.filters, page: 'glp' });
    }

    ngOnInit() {}

    updateSelectQueryData() {
        const subscriber = Subscriber.create<ResponseWrapper<any> | null>(
            value => {
                if (value?.success) {
                    plainToClassFromExist(this.pageData, value.data);
                } else {
                    plainToClassFromExist(this.errors, value?.errors);
                }
            },
            error => {},
            () => {
                this.showShimmer = false;
            }
        );

        this.marcheAPIService
            .getRequest<ResponseWrapper<any> | null>(
                GenericListingPageComponent.GLP_API,
                this.filters
            )
            .subscribe(subscriber);
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
